const KAKAO_AUTH_BASE_URL = 'https://kauth.kakao.com/oauth/authorize';
const KAKAO_OAUTH_SCOPE =
  process.env.REACT_APP_KAKAO_OAUTH_SCOPE || 'account_email,profile_nickname';

export function buildKakaoAuthorizeUrl() {
  const clientId = process.env.REACT_APP_KAKAO_REST_API_KEY;
  const redirectUri = process.env.REACT_APP_KAKAO_REDIRECT_URI;

  if (!clientId || !redirectUri) {
    return null;
  }

  const query = new URLSearchParams({
    response_type: 'code',
    client_id: clientId,
    redirect_uri: redirectUri,
  });
  if (KAKAO_OAUTH_SCOPE) {
    query.set('scope', KAKAO_OAUTH_SCOPE);
  }

  return `${KAKAO_AUTH_BASE_URL}?${query.toString()}`;
}
